import {
  Device,
  SARData,
  StepData,
  TrackingMetaData,
} from './trackingDataModel';
import { TrackingUpdateAction } from './actions';

export class TrackingHandlerBase<T> {
  updateDeviceInfo?(device: Partial<Device>, data: T): Partial<T> | null;

  updateTrackingMetadata?(
    trackingMetadata: TrackingMetaData,
    data: T
  ): Partial<T> | null;
  updateSARConsentInfo?(sarData: SARData, data: T): Partial<T> | null;
  updateFromQueryParams?(params: string, data: T): Partial<T> | null;
  updateOnStepChange?(step: StepData, data: T): Partial<T> | null;
  handleCustomAction?(action: TrackingUpdateAction, data: T): Partial<T> | null;
  updateOnSuccess?(successPageId: string, data: T): Partial<T> | null;
  updateOnLogin?(
    payload: { name: string; timestamp: string },
    data: T
  ): Partial<T> | null;
}
